import { render, staticRenderFns } from "./cDataCaptureForm.vue?vue&type=template&id=dfb6796e&scoped=true"
import script from "./cDataCaptureForm.vue?vue&type=script&lang=js"
export * from "./cDataCaptureForm.vue?vue&type=script&lang=js"
import style0 from "./cDataCaptureForm.vue?vue&type=style&index=0&id=dfb6796e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb6796e",
  null
  
)

export default component.exports